import { useEffect, useState, useCallback } from 'react';
import fleetApi from '../services/api.service';
import { useSelector } from 'react-redux';

export default function useCheckOnboarding() {
  const [onboardingStatus, setOnboardingStatus] = useState({
    needsOnboarding: false,
    hasWarehouses: false,
    hasVehicles: false,
    isLoading: true,
  });

  const features = useSelector((state) => state.features);

  const checkOnboarding = useCallback(async () => {
    try {
      setOnboardingStatus((prev) => ({ ...prev, isLoading: true }));

      // Check if onboarding was already completed in localStorage
      const onboardingCompleted = localStorage.getItem('onboardingCompleted');
      if (onboardingCompleted === 'true') {
        setOnboardingStatus({
          needsOnboarding: false,
          hasWarehouses: true,
          hasVehicles: true,
          isLoading: false,
        });
        return;
      }

      // Fetch warehouses and vehicles
      const [warehousesResponse, vehiclesResponse] = await Promise.all([
        fleetApi.get('/factories'),
        fleetApi.get('/vehicles?limit=1'),
      ]);

      const hasWarehouses =
        warehousesResponse.status === 200 &&
        warehousesResponse.data?.data?.length > 0;
      const hasVehicles =
        vehiclesResponse.status === 200 &&
        vehiclesResponse?.data?.items?.length > 0;

      const needsOnboarding =
        features?.TOUR_PLANNING?.TRUCK_ASSIGNMENTS?.enabled &&
        features?.TOUR_PLANNING?.WAREHOUSES?.enabled &&
        (!hasWarehouses || !hasVehicles);

      // If feature is enabled AND both warehouses and vehicles are setup, mark onboarding as completed
      if (!needsOnboarding) {
        localStorage.setItem('onboardingCompleted', 'true');
      }

      setOnboardingStatus({
        needsOnboarding,
        hasWarehouses,
        hasVehicles,
        isLoading: false,
      });
    } catch (error) {
      console.error('Error checking onboarding status:', error);
      setOnboardingStatus({
        needsOnboarding: false,
        hasWarehouses: false,
        hasVehicles: false,
        isLoading: false,
      });
    }
  }, []);

  useEffect(() => {
    checkOnboarding();
  }, [checkOnboarding]);

  return { ...onboardingStatus, refetch: checkOnboarding };
}
